<template>
  <div class="popularize">
    <div class="popularize-header">
      <div class="row">
        <div class="left">
          <img src="@/assets/vip/recommend@2x.png" alt="" />
          <p>推广免费获取VIP会员</p>
        </div>
        <div class="right" @click="navigateToPopularize">
          <p>推广记录</p>
          <img src="@/assets/vip/right@2x.png" alt="" />
        </div>
      </div>
      <div class="row">
        <p class="introduction">每成功推广1人，奖励1天黄金VIP会员</p>
      </div>
    </div>
    <div class="popularize-content">
      <div class="item">
        <p class="number">{{ popularizePeople }}人</p>
        <p class="text">已推广人数</p>
      </div>
      <div class="item">
        <p class="number">{{ freeVipDay }}天</p>
        <p class="text">可领取天数</p>
      </div>
    </div>
    <div class="popularize-footer">
      <button class="get" @click="gainVipDay">点击领取</button>
      <button @click="navigateToInvite" class="go">
        去推广
      </button>
    </div>
  </div>
</template>
<script>
import { getSharedInfo, gainFreeVipDay } from "@/api/vip";
import { mapActions, mapState } from "vuex";

export default {
  name: "Popularize",
  created() {
    this.fetchData();
  },
  computed: {
    ...mapState("user", ["isVip"])
  },
  data() {
    return {
      popularizePeople: 0,
      freeVipDay: 0
    };
  },
  methods: {
    ...mapActions("user", ["getInfo"]),
    async fetchData() {
      if (this.isVip) {
        const { day, count } = await getSharedInfo();
        this.freeVipDay = day;
        this.popularizePeople = count;
      } else {
        this.freeVipDay = 0;
        this.popularizePeople = 0;
      }
    },
    navigateToPopularize() {
      this.$router.push({ name: "popularize" });
    },
    navigateToInvite() {
      this.$router.push({ name: "invite" });
    },
    async gainVipDay() {
      const result = await gainFreeVipDay();
      this.$toast(result.msg);
      await this.fetchData();
      await this.getInfo();
    }
  }
};
</script>
<style lang="scss" scoped>
.popularize {
  width: 100%;
  background: rgba(60, 61, 72, 1);
  border-radius: 12px 12px 0 0;
  color: #fff;
  .popularize-header {
    display: flex;
    flex-direction: column;
    height: 80px;
    padding: 15px;
    border-bottom: 1px solid rgba(80, 81, 95, 1);
    .row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left {
        display: flex;
        align-items: center;
        img {
          margin-right: 5px;
          width: 26px;
          height: 23px;
        }
        p {
          font-size: 18px;
          font-weight: 500;
          color: rgba(255, 255, 255, 1);
          line-height: 25px;
        }
      }
      .right {
        display: flex;
        align-items: center;
        img {
          margin-left: 5px;
          width: 10px;
          height: 14px;
        }
        p {
          font-size: 14px;
          font-weight: 400;
          color: rgba(201, 202, 216, 1);
          line-height: 20px;
        }
      }
      .introduction {
        margin-top: 6px;
        height: 20px;
        font-size: 14px;
        font-weight: 500;
        color: rgba(255, 117, 0, 1);
        line-height: 20px;
      }
    }
  }
  .popularize-content {
    display: flex;
    justify-content: center;
    .item {
      margin: 0 47px;
      .number {
        margin: 20px 0 10px 0;
        font-size: 24px;
        font-weight: 800;
        color: rgba(255, 255, 255, 1);
        line-height: 33px;
      }
      .text {
        font-size: 14px;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        line-height: 20px;
      }
    }
  }
  .popularize-footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px 80px;
    .get {
      margin-bottom: 20px;
      width: 100%;
      height: 46px;
      border-radius: 28px;
      border: 1px solid rgba(228, 191, 88, 1);
      font-size: 15px;
      font-weight: 500;
      background-color: transparent;
      color: rgba(228, 191, 88, 1);
      line-height: 21px;
    }
    .go {
      border: none;
      width: 100%;
      height: 46px;
      background: linear-gradient(
        270deg,
        rgba(242, 201, 91, 1) 0%,
        rgba(254, 222, 136, 1) 100%
      );
      border-radius: 28px;
      font-size: 15px;
      font-weight: 500;
      color: rgba(111, 69, 8, 1);
      line-height: 46px;
    }
  }
}
</style>
